import React from "react";
import { aboutData } from "../../secondUtils/constants";
import { FaCaretRight } from "react-icons/fa";
import { AboutComponent } from "../../SecondComponents";

const SecondAbout = (props) => {
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    return (
        <div className="main">
            <div className="second-design-service-container">
                <div className="service-top-div">
                    <div>
                        <h1>{selectedLanguage?.txt_about_page_2}</h1>
                    </div>
                </div>
                <div className="about-container" data-aos="fade-down"
                    data-aos-easing="ease-out-bounce"
                    data-aos-delay="300"
                    data-aos-duration="2000">
                    <h2 className="about-heading">{selectedLanguage?.txt_pain} <span>{selectedLanguage?.txt_free_dentistry}</span></h2>
                    <div className='about-cards-div'>
                        {
                            aboutData?.map((v, i) => {
                                return (
                                    <div>
                                        <img src={v?.imageUrl} alt="" />
                                        <h2>
                                            {isELSelect ? v?.heading : (isAlSelect ? v?.alHeading : v?.glHeading)}
                                        </h2>
                                        <p>
                                            {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                        </p>
                                        <button className='about-cards-btn'>{selectedLanguage?.read_more_button} <FaCaretRight className="about-cards-btn-icon" /> </button>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            <div>
                <AboutComponent {...props} />
            </div>
        </div>
    )
}

export default SecondAbout 